import * as fromDatatype from "../datatype-library/index";

export interface bl_login_subject_to_employee_link_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	subject_guid: fromDatatype.GuidDataFieldInterface;
	employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}

export class bl_login_subject_to_employee_link_RowClass implements bl_login_subject_to_employee_link_RowInterface
{
	guid: fromDatatype.GuidDataFieldInterface;
	subject_guid: fromDatatype.GuidDataFieldInterface;
	employee_hdr_guid: fromDatatype.GuidDataFieldInterface;
	applet_guid: fromDatatype.GuidDataFieldInterface;
	module_guid: fromDatatype.GuidDataFieldInterface;
    namespace: fromDatatype.VarcharDatatypeInterface;
	description: fromDatatype.TextDatatypeInterface;
	property_json: fromDatatype.JsonDatatypeInterface;
	created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
	created_date: fromDatatype.TimestampTzDatatypeInterface;
	updated_date: fromDatatype.TimestampTzDatatypeInterface;
	acl_config: fromDatatype.JsonDatatypeInterface;
	acl_policy: fromDatatype.JsonDatatypeInterface;
	status: fromDatatype.StatusDataFieldInterface;
	revision: fromDatatype.RevisionDataFieldInterface;
	vrsn: fromDatatype.VrsnDataFieldInterface;
}
